import { useEffect } from 'react';

import { config } from '../config';

export const useGoogleTag = (event: string) => {
  useEffect(() => {
    if (!config.gtag) return;

    gtag('event', event);

    if (!config.aw_gtag) return;
    else gtag('event', event);
  }, [event]);
};
